import { StructuredDataFaq } from '@/services/structured-data-pages.service';

interface FaqSchemaProps {
  faqs: StructuredDataFaq[];
}

const FaqSchema = ({ faqs }: FaqSchemaProps) => {
  if (!faqs.length) {
    return null;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
};

export default FaqSchema;